<template>
  <v-col :cols="width" class="center-content">
    <v-btn
      text
      class="config-btn"
      :disabled="disabled"
    >
      <v-row>
        <v-col cols="12" class="config-action">
          <v-icon
           :color="colour"
          >
            {{ actionIcon }}
          </v-icon>
          <v-icon v-if="displayArrow">
            {{ arrowDirection }}
          </v-icon>
        </v-col>
        <v-col cols="12" class="config-action">
          <span>{{ label }}</span>
        </v-col>
      </v-row>
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'ConfigAction',
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: true
    },
    arrow: {
      type: String,
      required: false,
      default: ''
    },
    width: {
      type: Number,
      required: false,
      default: 4
    },
    colour: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    actionIcon() {
      return `mdi-${this.icon}`;
    },
    displayArrow() {
      return this.arrow.length > 0 ? true : false;
    },
    arrowDirection() {
      return `mdi-arrow-${this.arrow}`
    }
  },
  methods: {
    clickEvent() {
      this.$emit('configActionClicked');
    }
  }
}
</script>

<style lang="scss" scoped>
  .config-action {
    padding: 0;
  }

  .center-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .config-btn {
    font-weight: 400;
    color: #0f74bb;
    padding: 0;
    height: 0;
    &:hover {
      cursor: pointer;
    }
  }
</style>